<template>
    <el-dialog
        title="供应商证件资料预警"
        :visible.sync="dialogVisible"
        width="40%">
        <p>{{warnObject}} 供应商，</p>
        <p>&emsp;&emsp;你好，证件缺失或过期将影响使用，请及时维护！</p>
        <div v-if="corporateList.length > 0">
            <p>供应商默认资质证件：</p>
            <p v-for="(item, index) in corporateList" :key="'info1' + index">&emsp;&emsp;{{item.warnObject}} 的 {{item.qualificationName}} {{item.warnType}}</p>
        </div>
        <div v-if="driverAvehicleList.length > 0">
            <p>司机/车辆默认资质证件：</p>
            <p v-for="(item, index) in driverAvehicleList" :key="'info2' + index">&emsp;&emsp;{{item.warnObject}} 的 {{item.qualificationName}} {{item.warnType}}</p>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
const SUPPLIER_QUALIFICATION = '供应商资质';
// const VEHICLE_QUALIFICATION = '车辆资质';
// const DRIVER_QUALIFICATION = '司机资质';
export default {
    computed: {
        ...mapGetters(['supplier', 'qualifications']),
        warnObject() {
            return this.qualifications.length > 0 ? this.qualifications[0].warnObject : '暂未获取';
        }
    },
    data() {
        return {
            dialogVisible: false,
            corporateList: [],
            driverAvehicleList: []
        };
    },
    methods: {
        initQualifications() {
            this.dialogVisible = true;
            this.qualifications.forEach(element => {
                if (element.qualificationType === SUPPLIER_QUALIFICATION) {
                    this.corporateList.push(element);
                } else {
                    this.driverAvehicleList.push(element);
                }
            });
        }
    },
    created() {
        if (this.qualifications.length > 0) {
            this.initQualifications();
        }
    }
};
</script>